export enum documentTypes {
    consent = 0,
    consentSpouse = 1,
    promissoryNote = 2
};